// Space type options
export const SPACE_TYPES = [
  { value: 'studio', label: 'Studio' },
  { value: 'outdoor', label: 'Outdoor' },
  { value: 'retreat_center', label: 'Retreat Center' },
  { value: 'community_hall', label: 'Community Hall' },
  { value: 'online', label: 'Online' },
]

// Initial form state for creating spaces
export const INITIAL_SPACE_FORM = {
  facilitatorProfileId: '',
  name: '',
  description: '',
  spaceType: '',
  addressLine1: '',
  city: '',
  state: '',
  pincode: '',
  googleMapsUrl: '',
  contactName: '',
  contactPhone: '',
  contactEmail: '',
  capacity: '',
}

// Event format options
export const EVENT_FORMATS = [
  { value: 'in-person', label: 'In-Person' },
  { value: 'online', label: 'Online' },
  { value: 'hybrid', label: 'Hybrid' },
]

// Event status options
export const EVENT_STATUSES = [
  { value: 'draft', label: 'Draft' },
  { value: 'published', label: 'Published' },
  { value: 'cancelled', label: 'Cancelled' },
]

// Initial form state for creating events
export const INITIAL_EVENT_FORM = {
  name: '',
  eventDate: '',
  endDate: '',
  format: 'in-person',
  spaceId: '',
  location: '',
  venueLink: '',
  shortDescription: '',
  detailedDescription: '',
  fee: '',
  registrationLink: '',
  registrationOpen: true,
  maxAttendees: '',
  formType: '',
  paymentGatewayEnabled: false,
  status: 'published',
  facilitatorIds: [],
  externalFacilitators: [],
}
